import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule, Routes } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { RouteLabels } from '../../enums/routeLabels.enum';
import { AuthGuard } from '../../shared/auth.guard';
import { DeactivateFCPComponent } from './deactivate-fcp/deactivate-fcp.component';
import { EnablingClosingProcess } from './enabling-closing-process/enabling-closing-process.component';

const routes: Routes = [
    {
        path: '',
        component: EnablingClosingProcess,
        canActivate: [AuthGuard],
        data: {
            label: RouteLabels.CLOSING_PROCESS_ENABLING,
        },
    },
];

@NgModule({
    imports: [
        CommonModule,
        I18NextModule,
        RouterModule.forChild(routes),
        ReactiveFormsModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    declarations: [DeactivateFCPComponent],
})
export class EnablingClosingProcessModule {}
